<form [formGroup]="requestAccessForm" (ngSubmit)="onSubmit()">
  <!-- max-height is only constrained when the modal is NOT full-screen.
       calc(80vh - 3rem - 4rem - 2rem) breaks down as:
         80vh  = modal container max height
         3rem  = ix-modal-header height
         4rem  = ix-modal-footer height
         2rem  = total vertical padding inside ix-modal-content
       This ensures the scrollable content area fills the available space without
       causing the footer buttons to be pushed off-screen.
       If the iX modal dimensions change, the values here must be adapted accordingly -->
  <ix-modal-content
    [style.max-height]="size !== 'full-screen' ? 'calc(80vh - 3rem - 4rem - 2rem)' : null">
    
    <ix-input
      [class.ix-invalid]="firstName.invalid && (firstName.dirty || firstName.touched)"
      class="mb-2 w-100"
      formControlName="firstName"
      [required]="true"
      type="text"
      [label]="'battery_pass.public.request_access_form.label_first_name' | translate"
      [invalidText]="firstNameInvalidText" />

    <ix-input
      [class.ix-invalid]="lastName.invalid && (lastName.dirty || lastName.touched)"
      class="mb-2 w-100"
      formControlName="lastName"
      [required]="true"
      [label]="'battery_pass.public.request_access_form.label_last_name' | translate"
      type="text"
      [invalidText]="lastNameInvalidText" />

    <ix-input
      [class.ix-invalid]="email.invalid && (email.dirty || email.touched)"
      class="mb-2 w-100"
      formControlName="email"
      [required]="true"
      [label]="'battery_pass.public.request_access_form.label_email' | translate"
      type="text"
      [invalidText]="emailInvalidText">
      <ix-icon name="e-mail" size="16" slot="start"></ix-icon>
    </ix-input>
    
    <ix-input
      [class.ix-invalid]="organization.invalid && (organization.dirty || organization.touched)"
      class="mb-2 w-100"
      formControlName="organization"
      [required]="true"
      [label]="'battery_pass.public.request_access_form.label_organization' | translate"
      type="text"
      [invalidText]="organizationInvalidText" />

    <ix-textarea
      id="textarea"
      textareaWidth="100%"
      [required]="true"
      [class.ix-invalid]="purposeOfAccess.invalid && (purposeOfAccess.dirty || purposeOfAccess.touched)"
      class="w-100"
      [label]="'battery_pass.public.request_access_form.label_purpose_of_access' | translate"
      formControlName="purposeOfAccess"
      name="purposeOfAccess"
      resize-behavior="none"
      max-length="300"
      [invalidText]="purposeOfAccessInvalidText">
    </ix-textarea>
    
    <ix-checkbox-group
      [class.ix-invalid]="hasBeenSubmitted && requestAccessForm.hasError('atLeastOneRole')"
      [label]="'battery_pass.public.request_access_form.label_desired_roles' | translate"
      class="w-100"
      [invalidText]="rolesInvalidText">
      <ix-checkbox
        [required]="true"
        formControlName="roleCommission"
        [label]="'battery_pass.public.request_access_form.role_commission' | translate"></ix-checkbox>
      <ix-checkbox
        formControlName="roleNotifiedBodies"
        [label]="'battery_pass.public.request_access_form.role_notified_bodies' | translate"></ix-checkbox>
      <ix-checkbox
        formControlName="roleMarketSurveillance"
        [label]="'battery_pass.public.request_access_form.role_market_surveillance' | translate"></ix-checkbox>
      <ix-checkbox
        formControlName="roleRepair"
        [label]="'battery_pass.public.request_access_form.role_repair' | translate"></ix-checkbox>
      <ix-checkbox
        formControlName="roleRecycler"
        [label]="'battery_pass.public.request_access_form.role_recycler' | translate"></ix-checkbox>
      <ix-checkbox
        formControlName="roleNatural"
        [label]="'battery_pass.public.request_access_form.role_natural' | translate"></ix-checkbox>
      <ix-checkbox
        formControlName="roleTreatmentFacility"
        [label]="'battery_pass.public.request_access_form.role_treatment_facility' | translate"></ix-checkbox>
    </ix-checkbox-group>

  </ix-modal-content>

  <ix-modal-footer class="d-flex align-items-center gap-3 mt-1">
    <!-- Hidden native submit button so the browser can trigger (ngSubmit) on Enter key press.
         ix-button is a web component and is not recognized as a submit button by the browser. -->
    <button type="submit" aria-hidden="true" class="d-none"></button>
    <ix-button
      id="requestAccessFormCancelButton"
      onkeypress=""
      variant="subtle-primary"
      class="dismiss-modal flex-shrink-0"
      (click)="cancelled.emit()">
      {{ 'battery_pass.public.request_access_form.button_cancel' | translate }}
    </ix-button>
    <ix-button
      id="requestAccessFormSubmitButton"
      onkeypress=""
      (click)="onSubmit()"
      variant="primary"
      class="flex-shrink-0">
      {{ 'battery_pass.public.request_access_form.button_submit' | translate }}
    </ix-button>
  </ix-modal-footer>
</form>
